import {Object3D, Vector3} from "three";
import Action from '../classes/Action';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import { CustomEventTypes, SaveModificationTypes } from '../globals';
import Scenario from "../classes/scenarioElements/Scenario";
import ProjectSaver from '../classes/ProjectSaver';
import MathUtils from '../classes/utilities/MathUtils';
import {ActionDescription, ActionParameters} from "../classes/api/APIDecorators";
import {RegisterActionWithAPI} from "../classes/api/Decorators";

@ActionDescription("Sets the position of the selected objects. If newPosition and oldPosition are the same, the action will not be executed. Returns void.")
@ActionParameters({objects: "Object3D[]", newPositions: "Vector3[]", oldPositions: "Vector3[]"})
@RegisterActionWithAPI("SetObjectPositionAction")
export default class SetObjectPositionAction extends Action
{
	constructor(objects: Object3D[], newPositions: Vector3[], oldPositions: Vector3[])
	{
		const actionName = objects.length > 1 ? "Translated objects" : "Translated " + objects[0].name;
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([objects, newPositions, isDefaultState],
			[objects, oldPositions, isDefaultState],
			actionName,
			[objects, newPositions, oldPositions]);
	}

	do(objects: Object3D[], positions: Vector3[], isDefaultState)
	{
		if (isDefaultState) DefaultSceneManager.getInstance().syncNativeObjectVectorProperty(objects, 'position', positions);
		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			object.position.copy(positions[i]);
			ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Position);
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectPositionChanged));
	}

	verify(objects: Object3D[], newPositions: Vector3[], oldPositions: Vector3[])
	{
		// check if arrays have compatible lengths
		if (objects.length === 0 || objects.length !== newPositions.length || objects.length !== oldPositions.length || newPositions.length !== oldPositions.length)
		{return false;}

		// check for difference between newPositions and oldPositions
		let difference = false;
		for (let i = 0; i < objects.length; i++)
		{
			if (!MathUtils.areVectorsEqual(newPositions[i], oldPositions[i]))
			{
				difference = true;
				break;
			}
		}

		return difference;
	}
}
